const { render, useState } = wp.element;

class MostViewNewsSideBar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const renderPosts = this.props.articleList.map((post, index) => {
      return (
        <li className="swiper-slide swiper-slide-active">
          <span className="mod__number">{index + 1}</span>
          <article className="news news--summary news--invert news--100-00">
            <figure className="news__media">
              <a href={post.url} title={post.title}></a>
              <img
                src={post.img}
                className="attachment-news--100-00 size-news--100-00 wp-post-image"
                loading="lazy"
                style={{ height: "75px", widht: "75px" }}
              ></img>
            </figure>
            <div className="news__data">
              <a
                className="news__section"
                href={post.url}
                title={post.category}
              >
                {post.category}
              </a>
              <h2 className="news__title">
                <a href={post.url} title={post.title}>
                  {post.title}
                </a>
              </h2>
            </div>
          </article>
        </li>
      );
    });

    return (
      <div className="mod mod--morereads">
        <div className="mod__header">
          <h3 className="mod__title">{this.props.blockName}</h3>
        </div>
        <ol
          className="mod__content"
          data-swiper="{slidesPerView: 'auto', spaceBetween:16, simulateTouch:false, paginationClickable:true}"
        >
          <div className="swiper-container">
            <div className="swiper-wrapper">{renderPosts}</div>
            <div className="swiper-action">
              <div
                className="swiper-pagination"
                style={{ marginTop: "150px" }}
              ></div>
            </div>
          </div>
        </ol>
      </div>
    );
  }
}

const element = document.getElementById(params_most_views.elementId);
if (element) {
  render(
    <MostViewNewsSideBar
      articleList={params_most_views.mostViewPosts}
      blockName={params_most_views.componentName}
    />,
    element
  );
}

// Add swiper only if is on mobile
if (window.screen.height < 700) {
  var mySwiper = new Swiper(".swiper-container", {
    pagination: {
      el: ".swiper-pagination",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
    },
  });
}
